import React from "react";
import classes from "./style.module.scss";
import { TAllMarkets } from "../../types/markets/market";
import LoadingDiv from "../customersV2/loader";
import MemoizedGaugeChartNewUI from "./gauge-meter";
import UserAvatar from "../../components/avatar";
import { MarketsBarChart } from "./markets-bar-chart";
import UserAccountStatusString from "../customer/CustomerDetails/status-string";
import { ArrowForwardIos } from "@mui/icons-material";
import NodataAvailable from "../../assets/images/NodataAvailable.svg";
import { getMarketStatusDisplayIcon } from "../../helpers/getText";
type MarketsTableProps = {
  data: TAllMarkets[];
  loading: boolean;
  onRowClick: (row: TAllMarkets) => void;
};
const barColors = ["#067818", "#16A02C", "#89C692", "#C3E9C9"];
const MarketsTable: React.FC<MarketsTableProps> = ({
  data,
  loading,
  onRowClick,
}) => {
  return (
    <div
      className={`${classes.tablewrapper} bg-white mt-4`}
      style={{ height: "calc(100vh - 13rem)" }}
      id="scroll_style"
    >
      <div className={`${classes.tablecontainer_mos}`}>
        <table
          border={1}
          style={{ width: "100%", borderCollapse: "collapse" }}
          className="customers_table"
        >
          <thead>
            <tr>
              <th
                style={{ width: "50px", minWidth: "50px", textAlign: "center" }}
                className="bg-oceangreen color-text-primary"
              >
                #
              </th>

              <th
                style={{ width: "180px", minWidth: "180px" }}
                className="bg-oceangreen color-text-primary"
              >
                Market Name
              </th>

              <th
                style={{ width: "150px", minWidth: "150px" }}
                className="bg-oceangreen color-text-primary"
              >
                Market Head
              </th>

              <th
                style={{ width: "220px", minWidth: "220px" }}
                className="bg-oceangreen color-text-primary"
              >
                mOS Users
              </th>

              <th
                style={{ width: "160px", minWidth: "160px" }}
                className="bg-oceangreen color-text-primary"
              >
                Market Status
              </th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="py-8">
                  <div className="flex items-center justify-center h-full">
                    <LoadingDiv />
                  </div>
                </td>
              </tr>
            ) : data?.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr
                  key={row.marketId ?? rowIndex}
                  onClick={() => onRowClick(row)}
                  className={`${data.length - 1 === rowIndex ? "border-b" : ""
                    } hv-primary cursor-pointer`}
                >
                  {/* SL NO */}
                  <td
                    className={`${classes.textCenter} ${classes.rowAlignClass}`}
                  >
                    {rowIndex + 1}
                  </td>

                  {/* MARKET NAME */}
                  <td className={classes.rowAlignClass}>
                    <div className="flex gap-2 justify-between items-center">
                      <div className="flex flex-col">
                        <span className="text-sm">{row.marketName}</span>

                        <span className="text-xs color-sub-text">
                          MARKET ID:{" "}
                          <span className="color-blue">{row.marketId}</span>
                        </span>

                        <span className="text-xs color-sub-text">
                          {[
                            row.addressLine,
                            row.city,
                            row.state,
                            row.pincode ? `- ${row.pincode}` : "",
                          ]
                            .filter(Boolean)
                            .join(", ")}
                        </span>
                      </div>

                      {/* ORS */}
                      <div className="flex items-end">
                        <div className="flex flex-col items-center">
                          <MemoizedGaugeChartNewUI
                            id={`gauge-chart-${rowIndex}`}
                            percent={row.ors ? row.ors / 10 : 0}
                          />

                          <div
                            className={`font-semibold text-sm text-center
                              ${row.ors !== undefined && row.ors <= 3
                                ? "color-red"
                                : row.ors !== undefined && row.ors <= 5
                                  ? "color-red"
                                  : row.ors !== undefined && row.ors <= 7
                                    ? "color-orange"
                                    : row.ors !== undefined && row.ors <= 9
                                      ? "color-primary"
                                      : row.ors === 10
                                        ? "color-primary"
                                        : ""
                              }
                            `}
                          >
                            {row.ors ?? 0} / 10{" "}
                            {row.ors !== undefined && row.ors <= 3
                              ? "Very High"
                              : row.ors !== undefined && row.ors <= 5
                                ? "High"
                                : row.ors !== undefined && row.ors <= 7
                                  ? "Moderate"
                                  : row.ors !== undefined && row.ors <= 9
                                    ? "Low"
                                    : row.ors === 10
                                      ? "Very Good"
                                      : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>

                  {/* MARKET HEAD */}
                  <td>
                    {row.employeeName ? (
                      <div className="flex gap-2">
                        <div>
                          {row.profilePic ? (
                            <img
                              src={row.profilePic}
                              alt="user"
                              className="w-8 h-8 br-100"
                              style={{ maxWidth: "initial" }}
                            />
                          ) : (
                            <UserAvatar name={row.employeeName} />
                          )}
                        </div>

                        <div className="flex flex-col">
                          <span className="text-sm">{row.employeeName}</span>

                          <div className="text-xs color-sub-text">
                            {row.rmId && (
                              <>
                                ONO ID:{" "}
                                <span className="color-blue">{row.rmId}</span>
                                {" | "}
                              </>
                            )}
                            {row.mobile}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <span className="text-sm">No RM Assigned</span>
                    )}
                  </td>

                  {/* USERS */}
                  <td className={`h-[78px] ${classes.rowAlignClass}`}>
                    <div className="flex gap-6 items-center w-100">
                      <div className="text-sm text-center w-10">
                        {row.users?.total ?? 0}
                      </div>

                      <div className="border-l pl-3 w-80">
                        <MarketsBarChart
                          data={[
                            {
                              label: "CLICK",
                              value: row.users?.clickCount ?? 0,
                            },
                            {
                              label: "TRADE",
                              value: row.users?.tradeCount ?? 0,
                            },
                            {
                              label: "CASH",
                              value: Number(row.users?.cashCount ?? 0),
                            },
                          ]}
                          colors={barColors}
                        />
                      </div>
                    </div>
                  </td>

                  {/* STATUS */}
                  <td className={classes.rowAlignClass}>
                    <div className="flex gap-2 items-center justify-between">
                      <span className="font-semibold text-sm">
                        <UserAccountStatusString
                          statusIcon={getMarketStatusDisplayIcon({
                            status:
                              row.status === 0
                                ? "INACTIVE"
                                : row.status === 1
                                  ? "ACTIVE"
                                  : row.status === 2
                                    ? "UNDER REVIEW"
                                    : row.status === 3
                                      ? "REJECTED"
                                      : ""
                          })}
                          isIconNeed={false}
                        />
                      </span>

                      <div className="br-100 icon_bg w-[25px] h-[25px] flex items-center justify-center">
                        <ArrowForwardIos fontSize="small" />
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="py-8">
                  <div className="flex items-center justify-center h-full">
                    <img src={NodataAvailable} alt="No data available" />
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MarketsTable;
